import React, { useState } from "react";
import { Loader2, Copy, Check } from "lucide-react";
import { api } from "@/lib/api";

export const ARGUS_TOKEN = "argus_token";
export const aH = () => { const t = localStorage.getItem(ARGUS_TOKEN); return t ? { Authorization: `Bearer ${t}` } : {}; };
export const aErr = (e, fb = "Something went wrong") => { const d = e?.response?.data?.detail; return typeof d === "string" ? d : fb; };
export const argus = {
  get: (u, o = {}) => api.get(`/argus${u}`, { ...o, headers: aH() }),
  post: (u, b, o = {}) => api.post(`/argus${u}`, b, { timeout: 120000, ...o, headers: { ...aH(), ...(o.headers || {}) } }).then(r => {
    if (/\/extract$|\/claims$|\/letters$/.test(u)) window.dispatchEvent(new Event("argus-used"));
    return r;
  }),
  patch: (u, b) => api.patch(`/argus${u}`, b, { headers: aH() }),
  put: (u, b) => api.put(`/argus${u}`, b, { headers: aH() }),
  del: (u) => api.delete(`/argus${u}`, { headers: aH() }),
};

export function Label({ children }) {
  return <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#10b981]/80">{children}</div>;
}

export function Btn({ busy, children, kind = "solid", className = "", ...p }) {
  const base = kind === "solid" ? "bg-[#10b981] text-[#01170d] hover:bg-[#34d399] shadow-[0_0_18px_rgba(16,185,129,0.35)] hover:shadow-[0_0_26px_rgba(52,211,153,0.55)]" : kind === "danger" ? "text-red-300 hover:bg-red-500/10 border border-red-400/20" : "border border-white/15 text-white/80 hover:border-[#10b981]/60 hover:text-white";
  return (
    <button type="button" disabled={busy || p.disabled} {...p}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold transition-colors disabled:opacity-50 ${base} ${className}`}>
      {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />}{children}
    </button>
  );
}

export function CopyBtn({ text, testId, light = false }) {
  const [ok, setOk] = useState(false);
  return (
    <Btn kind="ghost" data-testid={testId} className="" onClick={() => { navigator.clipboard.writeText(text || ""); setOk(true); setTimeout(() => setOk(false), 1400); }}>
      {ok ? <Check className={`w-3.5 h-3.5 ${light ? "text-emerald-400" : "text-emerald-400"}`} /> : <Copy className="w-3.5 h-3.5" />} {ok ? "Copied" : "Copy"}
    </Btn>
  );
}

export const inputCls = "w-full bg-[#030f0a]/75 border border-emerald-400/20 rounded-md px-3 py-2 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-[#34d399] focus:ring-2 focus:ring-[#34d399]/30";
